/* FRONT PAGE SCRIPTS */

jQuery(document).ready(function($) {	
	initHellobar();	
});


function initHellobar(){
	var helloBarContainer = jQuery('#hello-bar-main');
	if(helloBarContainer.length){
		jQuery('#hello-bar-close-btn').click(function() {
		 helloBarContainer.animate({
			  maxHeight: '0',
			  opacity: '0',
			  padding: '0',
			});
		});	
	}
}

// VIDEO FOR FRONT PAGE
function initHpVideo() {		
			var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		
	jQuery('.banner-wrapper .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false; 
		
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".banner-wrapper .video").addClass("mobile");
			jQuery(".banner-wrapper .video").removeClass("desktop");
		} else {
			jQuery(".banner-wrapper .video").addClass("desktop");
		}
	});
}